import { Badge, Card, Group, Progress, Stack, Text } from '@mantine/core';
import { Cpu, MapPin, Smartphone } from 'lucide-react';
import { LOCKER_STATE_META, lockerState } from '@/api/lockers';
import type { LockerHealth } from '@/api/types';
import { timeAgo } from '@/lib/format';

export function LockerCard({ locker, onClick }: { locker: LockerHealth; onClick?: () => void }) {
    const state = lockerState(locker);
    const meta = LOCKER_STATE_META[state];
    const total = locker.total_cells || 0;
    const sellable = locker.sellable_cells || 0;
    const percent = total > 0 ? Math.round((sellable / total) * 100) : 0;
    const SoftIcon = locker.software_type === 'rpi' ? Cpu : Smartphone;

    return (
        <Card
            className={onClick ? 'ff-clickable' : undefined}
            onClick={onClick}
            style={state !== 'online' ? { borderColor: `var(--mantine-color-${meta.color}-filled)` } : undefined}
        >
            <Stack gap="sm">
                <Group justify="space-between" align="flex-start" wrap="nowrap">
                    <Text fw={800} fz="lg" lh={1.2}>
                        {locker.display_name || locker.id}
                    </Text>
                    <Badge color={meta.color} variant={state === 'online' ? 'light' : 'filled'} style={{ flexShrink: 0 }}>
                        {meta.label}
                    </Badge>
                </Group>
                <Group gap={6} c="dimmed">
                    <MapPin size={14} />
                    <Text size="sm">{locker.location_name || '—'}</Text>
                </Group>
                <div>
                    <Group justify="space-between" mb={6}>
                        <Text size="sm" c="dimmed">
                            Ячейки для продажи
                        </Text>
                        <Text size="sm" fw={700}>
                            {sellable} из {total || '—'}
                        </Text>
                    </Group>
                    <Progress value={percent} size="sm" radius="xl" />
                </div>
                <Group justify="space-between" c="dimmed">
                    <Group gap={6}>
                        <SoftIcon size={14} />
                        <Text size="xs">
                            {locker.software_type === 'rpi' ? 'RPi' : 'Android'}
                            {locker.version_name ? ` · v${locker.version_name}` : ''}
                        </Text>
                    </Group>
                    <Text size="xs">
                        {state === 'offline'
                            ? `нет связи ${locker.last_ws_offline_at ? timeAgo(locker.last_ws_offline_at) : ''}`
                            : `на связи ${timeAgo(locker.last_online_at)}`}
                    </Text>
                </Group>
            </Stack>
        </Card>
    );
}
